import type { SetState } from "zustand";

import type { AskPerformYardState } from "../types";

export const createFeatureSlice = (set: SetState<AskPerformYardState>) => ({
	hasNoDocuments: false,
	hasGoalCategories: true,
	cachedAskHrEnabled: false,
	cachedGoalCreationEnabled: false,
	cachedFormCreationEnabled: false,

	setHasNoDocuments: (hasNoDocuments: boolean) => set({ hasNoDocuments }),
	setHasGoalCategories: (hasGoalCategories: boolean) => set({ hasGoalCategories }),
});
